import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Tag,
  Badge,
  Empty,
  Table,
  Button,
  Modal,
  Typography,
  Row,
  Col,
  Card,
  Space,
  Image,
  Carousel,
} from "antd";
import {
  LoadingOutlined,
  CalendarOutlined,
  TableOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { get_language, translate } from "../../locale";
import moment from "moment";

import { useParams } from "react-router-dom";
import UserServices from "../../services/UserServices";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import SecondaryButton from "../Buttons/SecondaryButton";
import LogBookServices from "../../services/LogBookServices";

const localizer = momentLocalizer(moment);

const { Title, Text } = Typography;

const BreathingCalendar = () => {
  const [loading, setLoading] = useState(false);
  const [loadUser, setLoadUser] = useState(false);
  const [data, setData] = useState(null);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [patient, setPatient] = useState(null);
  const [dataTable, setDataTable] = useState(null);
  const [modalDetails, setModalDetails] = useState(null);
  const [showAs, setShowAs] = useState("calendar");

  const { username, subscription_medicine_patient_id } = useParams();
  const how_do_you_feel = [
    {
      label: "very_good",
      value: "Muy bien",
    },
    {
      label: "normal",
      value: "Normal",
    },
    {
      label: "very_bad",
      value: "Muy mal",
    },
  ];
  useEffect(() => {
    loadPatientInfo();
  }, []);

  const loadPatientInfo = async () => {
    try {
      setLoadUser(true);
      const res = await UserServices.getProfile(username);
      if (res.status >= 200 && res.status < 300) {
        setPatient(res.data.my_contact_info);
      }
      setLoadUser(false);
    } catch (error) {
      setLoadUser(false);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [date]);

  const fetchData = async () => {
    try {
      const response = await LogBookServices.getBreathing(username, date);
      if (
        response.status >= 200 &&
        response.status <= 300 &&
        response.data.breathing_cycle.length !== 0
      ) {
        let newData = response.data.breathing_cycle.map((i) => {
          const registerDate = i.register_date;
          const registerDatePlusOne = new Date(registerDate);
          registerDatePlusOne.setHours(registerDatePlusOne.getHours() + 1);

          return {
            minutes: i.minutes,
            como_te_fue: i.como_te_fue,
            difficulty: i.difficulty,
            start: new Date(i.register_date),
            end: registerDatePlusOne,
            cycles: i.cycles,
            type: "cell",
            formattedRegisterDate: moment(i.register_date).format("HH:mm:ss"),
          };
        });

        setDataTable(response.data.breathing_cycle);
        setData(newData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-4 justify-center">
          <Button
            type="text"
            icon={<EyeOutlined />}
            size="small"
            className="border-0"
            onClick={() => handleDetails(record)}
          />
        </div>
      ),
    },
    {
      title: "Fecha",
      dataIndex: "intake_date",
      key: "intake_date",
      render: (_, record) => {
        return moment(record.register_date).format(
          get_language === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
        );
      },
      sorter: (a, b) => {
        if (a.register_date < b.register_date) return -1;
        if (a.register_date > b.register_date) return 1;
        return 0;
      },
    },
    {
      title: "Hora",
      dataIndex: "intake_time",
      key: "intake_time",
      render: (_, record) => moment(record.register_date).format("HH:mm:ss"),
      sorter: (a, b) => {
        if (a.register_date < b.register_date) return -1;
        if (a.register_date > b.register_date) return 1;
        return 0;
      },
    },
  ];

  const handleHideDetails = () => {
    setModalDetails(null);
  };

  const handlePrev = () => {
    setDate((v) => moment(v).subtract(7, "days").format("YYYY-MM-DD"));
  };
  const handleToday = () => {
    setDate((v) => moment().format("YYYY-MM-DD"));
  };
  const handleNext = () => {
    if (date !== moment().format("YYYY-MM-DD")) {
      setDate((v) => moment(v).add(7, "days").format("YYYY-MM-DD"));
    }
  };
  const handleDetails = (item) => {
    setModalDetails(item);
  };
  return (
    <Row className="w-full">
      <Col flex="column" className="w-full" id="Breathing">
        <Row className="w-full">
          <Col span={24} className="mt-4">
            <Title level={2} className="text-center">
              {translate("Respiración de ")}
              {patient && `${patient.user.full_name}`}
            </Title>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col span={24} className="flex flex-row justify-end space-x-2">
            <span className="flex flex-col justify-center">
              {translate("Formato")}:
            </span>
            <Button
              icon={<CalendarOutlined />}
              onClick={() => setShowAs("calendar")}
              type={showAs === "calendar" ? "primary" : "default"}
            />
            <Button
              icon={<TableOutlined />}
              onClick={() => setShowAs("table")}
              type={showAs === "table" ? "primary" : "default"}
            />
          </Col>
        </Row>
        {showAs === "calendar" && (
          <Calendar
            localizer={localizer}
            defaultDate={null}
            defaultView={Views.WEEK}
            views={["week"]}
            events={data || []}
            startAccessor="start"
            endAccessor="end"
            step={60}
            timeslots={6}
            style={{ height: 500 }}
            components={{
              toolbar: (props) => (
                <div className="flex flex-row my-4">
                  <div>
                    <SecondaryButton
                      className="mr-4"
                      onClick={() => {
                        props.onNavigate("PREV");
                        handlePrev();
                      }}
                    >
                      &lt;
                    </SecondaryButton>
                    <SecondaryButton
                      className="mr-4"
                      onClick={() => {
                        props.onNavigate("TODAY");
                        handleToday();
                      }}
                    >
                      Hoy
                    </SecondaryButton>
                    <SecondaryButton
                      className=""
                      onClick={() => {
                        props.onNavigate("NEXT");
                        handleNext();
                      }}
                    >
                      &gt;
                    </SecondaryButton>
                  </div>
                  <div className="flex flex-1 flex-row justify-center items-center">
                    {props.label}
                  </div>
                </div>
              ),
              week: {
                event: ({ event }) => {
                  return (
                    <div
                      className={`text-center w-full ${
                        event.type === "cell" ? "" : "rbc-event-content-header"
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        if (event.type === "cell") {
                          handleDetails(event);
                        }
                      }}
                    >
                      {event.start.toString().indexOf("00:00:00") === -1
                        ? moment(event.start).format("HH:mm")
                        : event.title}
                    </div>
                  );
                },
              },
            }}
            formats={{
              eventTimeRangeFormat: () => {
                return "";
              },
              timeGutterFormat: (date, culture, localizer) => {
                const time = localizer.format(date, "HH:mm", culture);
                let rs = "";
                switch (time) {
                  case "00:00":
                    rs = "";
                    break;
                  case "06:00":
                    rs = "";
                    break;
                  case "12:00":
                    rs = "";
                    break;
                  case "18:00":
                    rs = "";
                    break;
                }
                return rs;
              },
            }}
          />
        )}
        {showAs === "table" && (
          <>
            <div className="flex flex-row my-4">
              <div>
                <SecondaryButton
                  className="mr-4"
                  onClick={() => {
                    handlePrev();
                  }}
                >
                  &lt;
                </SecondaryButton>
                <SecondaryButton
                  className="mr-4"
                  onClick={() => {
                    handleToday();
                  }}
                >
                  Hoy
                </SecondaryButton>
                <SecondaryButton
                  className=""
                  onClick={() => {
                    handleNext();
                  }}
                >
                  &gt;
                </SecondaryButton>
              </div>
            </div>
            <Table
              rowKey={(i) => i.id}
              className="w-full mt-6"
              dataSource={dataTable}
              columns={columns}
              loading={
                loading
                  ? { indicator: antIcon, className: "text-custom_blue" }
                  : false
              }
              locale={{
                emptyText: <Empty description={translate("No hay datos")} />,
                sortTitle: translate("Ordenar"),
                triggerDesc: translate("Ordenar (descendente)"),
                triggerAsc: translate("Ordenar (ascendente)"),
                cancelSort: translate("Cancelar orden"),
                filterTitle: translate("Filtros"),
                filterConfirm: translate("Aceptar"),
                filterReset: translate("Limpiar"),
                filterEmptyText: translate("No hay filtros"),
                filterCheckall: translate("Seleccinar todos"),
                filterSearchPlaceholder: translate("Buscar en filtros"),
              }}
            />
          </>
        )}
        <Modal
          width={600}
          open={modalDetails !== null}
          title={translate("Detalles del entrenamiento")}
          onCancel={handleHideDetails}
          footer={[
            <Button key="ok" type="primary" onClick={handleHideDetails}>
              {translate("Aceptar")}
            </Button>,
          ]}
        >
          {modalDetails !== null && (
            <Row>
              <Col className="flex-1">
                <Row className="mt-4">
                  <Col>
                    <Text>Minutos: {modalDetails.minutes}</Text>
                  </Col>
                </Row>
                <Row className="pb-4">
                  <Col span={14}></Col>
                </Row>
                <Row className="mt-3">
                  <Col>
                    <Text>
                      ¿Cómo te fue?:{" "}
                      {how_do_you_feel.find(
                        (item) => item.label === modalDetails.como_te_fue
                      )?.value || modalDetails.como_te_fue}
                    </Text>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Text>
                      Registrado a las {modalDetails.formattedRegisterDate}
                    </Text>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Text>Dificultad: {modalDetails.difficulty}</Text>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Text>Ciclos: {modalDetails.cycles}</Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Modal>
      </Col>
    </Row>
  );
};

export default BreathingCalendar;
